<!--
 Domain Form embed in generic wrapper.


 Events:
  created: Triggered when the domain is successfully created. Contains the new Domain in the payload
  error: Triggered when a attempt of creation fails. Contains an error message.

 Usage:
  Jade:
    domain-form-dialog(ref="domainsDialog")

  Javascript:
    this.$refs.domainsDialog.open();
-->
<template lang="pug">
dialog-form(ref='domainForm', :saveAction="saveAction", title="Create Domain", @closed='resetForm', :validationPending='$v.$pending')
  md-layout(:md-gutter='16')
    md-layout(md-flex='100')
      metadata-form(:entity='domainList', :form-submitted='formSubmitted', :validations='$v.domainList', title="")
    md-layout(md-flex='100')
      status-radio(v-model='domainList.status')
    md-layout(md-flex='100')
      md-chips(v-model='domainList.domains', :md-max='5', md-input-placeholder='Add domain target...',
                :class='{ "md-input-invalid" : formSubmitted && $v.domainList.domains.$invalid || $v.domainList.domains.$each.$invalid }')
        template(slot-scope='chip')
          span {{ chip.value }}
          span.md-error(v-if='!$v.domainList.domains.hasDomains') Define at least one domain
          span.md-error(v-if='$v.domainList.domains.$each.$invalid') Some of the domains has a worng format.
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  import { isValidDomain } from '../../services/validatorService';
  import DialogForm from './DialogForm';
  import domainService from '../../services/domainService';
  import MetadataForm from './MetadataForm';
  import StatusRadio from '../StatusRadio';

  export default {
    mixins: [validationMixin],
    components: {
      DialogForm,
      MetadataForm,
      StatusRadio
    },
    computed: {
      hasDomains() {
        return this.domainList.domains.length > 0;
      }
    },
    data() {
      return {
        domainList: {
          name: '',
          description: '',
          tags: [],
          status: 'draft',
          domains: []
        },
        formSubmitted: false
      };
    },
    validations: {
      domainList: {
        name: {
          required,
          async isUnique(value) {
            if (value) {
              const response = await domainService.getList({ exactName: value, limit: 1 });
              return response.data.total === 0;
            } else {
              return true;
            }
          }
        },
        shortDescription: {
          default: true
        },
        description: {
          default: true
        },
        domains: {
          $each: {
            validateDomain(value) {
              return isValidDomain(value);
            }
          },
          hasDomains() {
            return this.hasDomains;
          }
        }
      }
    },
    methods: {
      open() {
        this.$refs.domainForm.openDialog();
      },
      resetForm() {
        this.domainList = {
          name: '',
          description: '',
          tags: [],
          status: 'draft',
          domains: []
        };
        this.formSubmitted = false;
        this.$v.$reset();
      },
      createDomainList() {
        domainService.create(this.domainList)
          .catch(() => {
            this.alert = { msg: 'Domain list could not be created. Please, try again later.', success: false };
            this.$refs.alert.open();
          })
          .then(() => {
            this.creatingOrUpdating = false;
          });
      },
      async saveAction() {
        this.formSubmitted = true;
        if (this.$v.$invalid) {
          const error = { msg: 'Invalid form' };
          throw error;
        } else {
          try {
            const response = await domainService.create(this.domainList);
            this.$emit('created', response.data.domainlist);
            this.resetForm();
          } catch (e) {
            this.$emit('error', 'Domain creation failed. Please, try again later.');
            this.resetForm();
            throw e;
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-dialog {
    width: 50%;
    min-width: 50%;
  }
  .md-chips {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DomainFormDialog.vue